import React from 'react'
import PropTypes from 'prop-types'

import { Container, Ul, Li } from './styles'

const SimpleList = ({ data, renderItem }) => {
  return (
    <Container>
      <Ul>
        {data.map((item) => (
          <Li key={item.id}>{renderItem({ item })}</Li>
        ))}
      </Ul>
    </Container>
  )
}

export default SimpleList

SimpleList.propTypes = {
  data: PropTypes.array.isRequired,
  renderItem: PropTypes.func,
}

SimpleList.defaultProps = {
  renderItem: () => {},
}
